import axios from 'axios'
import { ElMessage } from 'element-plus'
const baseURL = "https://www.sdses.org.cn/api";
const service = axios.create({
  baseURL,
  timeout: 20000
})
// 请求拦截
service.interceptors.request.use(
  config => {
    // 自动携带 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 可扩展：自定义header、loading等
    return config
  },
  error => Promise.reject(error)
)
// 响应拦截
service.interceptors.response.use(
  response => {
    // 统一处理返回数据
    if (response.data.code == 200 || response.data.code == 1) {
      return response.data
    } else {
      // 统一错误提示
      ElMessage.error(response.data.msg || '请求失败')
      return Promise.reject(response.data)
    }
  },
  error => {
    // 网络/服务器错误处理
    ElMessage.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)
// 通用 GET 请求
export function get<T = any>(url: string, params?: any, config?: any): Promise<T> {
  return service.get(url, { params, ...config }).then(res => res.data as T)
}
// 通用 POST 请求
export function post<T = any>(url: string, data?: any, config?: any): Promise<T> {
  return service.post(url, data, { ...config }).then(res => res.data as T)
}
export default service
